module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vh-100 overflow-y-scroll pa4"
  }, [_c('div', {
    staticClass: "ma2 row"
  }, [_c('pl-button', {
    staticClass: "pl-primary",
    nativeOn: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("\n      < GO BACK\n    ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "mt4"
  }, [_c('span', {
    staticClass: "pl-title mb4"
  }, [_vm._v("Collections")]), _vm._v(" "), _c('div', {
    staticClass: "row mt3"
  }, [_c('pl-input', {
    ref: "input-native-tag",
    staticClass: "default col-xs-12 col-sm-8 col-md-6 col-lg-4",
    attrs: {
      "addon": _vm.addon,
      "placeholder": _vm.placeholder
    },
    on: {
      "input": _vm.search
    },
    model: {
      value: (_vm.searchCollection),
      callback: function($$v) {
        _vm.searchCollection = $$v
      },
      expression: "searchCollection"
    }
  }), _vm._v(" "), _c('pl-button', {
    staticClass: "pl-primary",
    nativeOn: {
      "click": function($event) {
        return _vm.createNewCollection.apply(null, arguments)
      }
    }
  }, [_vm._v("\n        CREATE NEW COLLECTION\n      ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "pv2"
  }, [_c('span', {
    staticClass: "ml1 pl-color-ruby"
  }, [_vm._v("(a position of 0 will exclude it from the universe home page)")]), _vm._v(" "), _c('ul', {
    staticClass: "row ph4"
  }, _vm._l((_vm.categories), function(category) {
    return _c('li', {
      key: category.name,
      staticClass: "col-xs-12 col-sm-8 col-md-6 col-lg-4"
    }, [_c('span', {
      staticClass: "pl-title"
    }, [_vm._v(_vm._s(category.name))]), _vm._v(" "), _c('pl-button', {
      staticClass: "pl-small pl-icon",
      nativeOn: {
        "click": function($event) {
          return _vm.editCategory(category.id)
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-edit"
    })]), _vm._v(" "), _c('pl-button', {
      staticClass: "pl-small pl-icon",
      nativeOn: {
        "click": function($event) {
          return _vm.deleteCategory(category.id)
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-remove"
    })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Default Position:")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (category.position),
        expression: "category.position"
      }],
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(category, "position", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.editCategoryPosition(category.id, $event)
        }]
      }
    }, _vm._l((_vm.categories.length + 1), function(position, index) {
      return _c('option', {
        key: category.name + index,
        domProps: {
          "value": index
        }
      }, [_vm._v("\n            " + _vm._s(index) + "\n          ")])
    }), 0)], 1)
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-12cdc767!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/admin/adminManageCollections.vue
// module id = 1935
// module chunks = 61